<template>
  <div class="reportList" v-loading="isloading">
    <el-row class="reportList-nav" id="reportListnav">
      <el-col>
        <el-form
          :inline="true"
          ref="search"
          size="mini"
          class="demo-form-inline"
        >
          <el-row class="nav-top">
            <el-col>
              <el-form-item label="统计类型">
                <el-radio-group v-model="type">
                  <el-radio-button label="检查量">检查量</el-radio-button>
                  <el-radio-button label="工作量">工作量</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <el-row v-if="type === '工作量'">
              <el-col>
                <el-form-item label="统计方式">
                  <el-radio-group v-model="manner">
                    <el-radio-button label="按诊断">按诊断</el-radio-button>
                    <el-radio-button label="按审核">按审核</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              ><!-- v-if="manner === '按时间段' " -->
              <el-col :span="22">
                <el-form-item label="时间选择">
                  <el-radio-group v-model="timeType">
                    <el-radio-button label="1">七天</el-radio-button>
                    <el-radio-button label="2">一个月</el-radio-button>
                    <el-radio-button label="3">一年</el-radio-button>
                    <el-radio-button label="4" class="nav-time">
                      <el-date-picker
                        v-model="DateArray"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :default-time="['00:00:00', '23:59:59']"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="changeTime"
                      ></el-date-picker>
                    </el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="type === '工作量'">
              <el-col>
                <el-form-item label="统计标准">
                  <el-radio-group
                    v-model="standard"
                    @change="GetDoctorsWorkByDepartId"
                  >
                    <el-radio-button label="1" value="1"
                      >按检查项目</el-radio-button
                    >
                    <el-radio-button label="2" value="2"
                      >按患者人次</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px" v-if="type === '检查量'">
      <el-col :span="16">
        <div>
          <el-row>
            <el-col :span="20">
              <h4 style="margin-top: 0px">医院检查量统计</h4>
            </el-col>
            <el-col :span="4">
              <el-button
                @click="excel"
                size="mini"
                style="width: 100%"
                type="primary"
                >导出Excel</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="reportList-table">
          <el-table stripe :data="hospWork" size="mini" style="width: 100%">
            <el-table-column
              prop="hospName"
              label="医院"
              min-width="140px"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="CR" label="CR" min-width="60">
            </el-table-column>
            <el-table-column prop="CT" label="CT" min-width="60">
            </el-table-column>
            <el-table-column prop="DX" label="DX" min-width="60">
            </el-table-column>
            <el-table-column prop="MR" label="MR" min-width="60">
            </el-table-column>
            <el-table-column prop="OT" label="OT" min-width="60">
            </el-table-column>
            <el-table-column prop="RF" label="RF" min-width="60">
            </el-table-column>
            <el-table-column prop="US" label="US" min-width="60">
            </el-table-column>
            <el-table-column prop="XA" label="XA" min-width="60">
            </el-table-column>
            <el-table-column prop="DR" label="DR" min-width="60">
            </el-table-column>
            <el-table-column prop="totalCount" label="总数"></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="8">
        <div
          style="
            width: 100%;
            display: inline-block;
            text-align: center;
            margin-top: 40px;
          "
        >
          <span style="color: #3a4a64">医院检查量</span>
          <Chart
            id="pie1"
            :type="true"
            :isHosp="pie1"
            :istype="watchObj"
            :options="hospWorkpi"
            :width="piewidth"
            :height="pieheight"
          ></Chart>
        </div>
        <div
          style="
            width: 100%;
            display: inline-block;
            text-align: center;
            margin-top: 40px;
          "
        >
          <span style="color: #3a4a64">设备检查量</span>
          <Chart
            id="pie2"
            :type="true"
            :isHosp="pie2"
            :istype="watchObj"
            :options="deviceWork"
            :width="piewidth"
            :height="pieheight"
          ></Chart>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px" v-else>
      <el-col :span="16">
        <div>
          <el-row>
            <el-col :span="20">
              <h4 style="margin-top: 0px">医生工作量统计</h4>
            </el-col>
            <el-col :span="4">
              <el-button
                @click="excel"
                size="mini"
                style="width: 100%"
                type="primary"
                >导出Excel</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="reportList-table">
          <el-table
            stripe
            :data="doctorsWork"
            size="mini"
            v-if="manner === '按诊断'"
            style="width: 100%"
          >
            <el-table-column
              prop="doctorName"
              label="医生姓名"
            ></el-table-column>
            <el-table-column prop="CCR" label="CR" min-width="60">
            </el-table-column>
            <el-table-column prop="CCT" label="CT" min-width="60">
            </el-table-column>
            <el-table-column prop="CDX" label="DX" min-width="60">
            </el-table-column>
            <el-table-column prop="CMR" label="MR" min-width="60">
            </el-table-column>
            <el-table-column prop="COT" label="OT" min-width="60">
            </el-table-column>
            <el-table-column prop="CRF" label="RF" min-width="60">
            </el-table-column>
            <el-table-column prop="CUS" label="US" min-width="60">
            </el-table-column>
            <el-table-column prop="CXA" label="XA" min-width="60">
            </el-table-column>
            <el-table-column prop="CDR" label="DR" min-width="60">
            </el-table-column>
            <el-table-column
              prop="createCount"
              label="诊断数量"
            ></el-table-column>
          </el-table>
          <el-table
            stripe
            :data="doctorsWork"
            size="mini"
            v-if="manner === '按审核'"
            style="width: 100%"
          >
            <el-table-column
              prop="doctorName"
              label="医生姓名"
            ></el-table-column>
            <el-table-column prop="ACR" label="CR" min-width="60">
            </el-table-column>
            <el-table-column prop="ACT" label="CT" min-width="60">
            </el-table-column>
            <el-table-column prop="ADX" label="DX" min-width="60">
            </el-table-column>
            <el-table-column prop="AMR" label="MR" min-width="60">
            </el-table-column>
            <el-table-column prop="AOT" label="OT" min-width="60">
            </el-table-column>
            <el-table-column prop="ARF" label="RF" min-width="60">
            </el-table-column>
            <el-table-column prop="AUS" label="US" min-width="60">
            </el-table-column>
            <el-table-column prop="AXA" label="XA" min-width="60">
            </el-table-column>
            <el-table-column prop="ADR" label="DR" min-width="60">
            </el-table-column>
            <el-table-column
              prop="firstApproveCount"
              label="审核数量"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="8">
        <div
          style="
            width: 100%;
            display: inline-block;
            text-align: center;
            margin-top: 40px;
          "
        >
          <span style="color: #3a4a64">医生诊断工作量</span>
          <Chart
            id="pie3"
            :type="true"
            :isHosp="pie3"
            :istype="watchObj"
            :options="crdoctorsWork"
            :width="piewidth"
            :height="pieheight"
          ></Chart>
        </div>
        <div
          style="
            width: 100%;
            display: inline-block;
            text-align: center;
            margin-top: 40px;
          "
        >
          <span style="color: #3a4a64">医生审核工作量</span>
          <Chart
            id="pie4"
            :type="true"
            :isHosp="pie4"
            :istype="watchObj"
            :options="apdoctorsWork"
            :width="piewidth"
            :height="pieheight"
          ></Chart>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Chart from "../Common/eCharts";
import { formatDate } from "@/utils/index.js";
import { mapGetters } from "vuex";
export default {
  name: "statistics",
  data() {
    return {
      type: "检查量",
      manner: "按诊断",
      standard: "1",
      DateArray: [
        formatDate(new Date(new Date() - 3600 * 1000 * 24 * 30), "yyyy-MM-dd"),
        formatDate(new Date(), "yyyy-MM-dd"),
      ],
      timeType: "2",
      id: "bar",
      pie1: "pie1",
      pie2: "pie2",
      pie3: "pie3",
      pie4: "pie4",
      piewidth: "100%",
      pieheight: "200px",
      barwidth: "100%",
      barheight: "300px",
      isloading: false,
    };
  },
  components: {
    Chart,
  },
  computed: {
    ...mapGetters([
      "doctorsWork",
      "hospWork",
      "deviceWork",
      "watchObj",
      "currentUserRoleDepart",
      "crdoctorsWork",
      "apdoctorsWork",
      "hospWorkpi",
    ]),
  },
  mounted() {
    this.GetModalityCountByDepartId();
    this.GetDoctorsWorkByDepartId();
  },
  methods: {
    checkTimeType(type) {
      if (type === "1") {
        this.DateArray = [
          formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), "yyyy-MM-dd"),
          formatDate(new Date(), "yyyy-MM-dd"),
        ];
      }
      if (type === "2") {
        this.DateArray = [
          formatDate(
            new Date(new Date() - 3600 * 1000 * 24 * 30),
            "yyyy-MM-dd"
          ),
          formatDate(new Date(), "yyyy-MM-dd"),
        ];
      }
      if (type === "3") {
        this.DateArray = [
          formatDate(
            new Date(new Date() - 3600 * 1000 * 24 * 365),
            "yyyy-MM-dd"
          ),
          formatDate(new Date(), "yyyy-MM-dd"),
        ];
      }
      if (type === "4") {
        this.DateArray = this.DateArray;
      }
    },
    changeTime: function () {
      this.timeType = 4;
    },
    GetDoctorsWorkByDepartId() {
      this.isloading = true;
      this.$store
        .dispatch("GetDoctorsWorkByDepartId", {
          startDate: this.DateArray[0],
          endDate: this.DateArray[1],
          visitors: this.standard === "1" ? false : true,
        })
        .then(() => {
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
      this.$store
        .dispatch("GetDoctorsWorkForPI", {
          startDate: this.DateArray[0],
          endDate: this.DateArray[1],
        })
        .then(() => {
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    excel() {
      var days =
        new Date(this.DateArray[1]).getTime() -
        new Date(this.DateArray[0]).getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      if (time > 31) {
        this.$message({
          message: "您所选的时间段大于一个月，不能导出Excel，请重新选择！",
          type: "warning",
        });
      } else {
        var date = new Date(this.DateArray[0]);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate();
        var startDate = Y + M + D;
        var date1 = new Date(this.DateArray[1]);
        var Y1 = date1.getFullYear() + "-";
        var M1 =
          (date1.getMonth() + 1 < 10
            ? "0" + (date1.getMonth() + 1)
            : date1.getMonth() + 1) + "-";
        var D1 = date1.getDate();
        var endDate = Y1 + M1 + D1;
        if (this.type === "检查量") {
          window.open(
            this.$getCfg("VUE_APP_BASE_API") +
              "/Statistics/GetModalityCountSheet?departId=" +
              this.currentUserRoleDepart.departId +
              "&startDate=" +
              startDate +
              "&endDate=" +
              endDate +
              "&fileName=",
            "_blank"
          );
        } else {
          window.open(
            this.$getCfg("VUE_APP_BASE_API") +
              "/Statistics/GetDoctorsWorkSheet?departId=" +
              this.currentUserRoleDepart.departId +
              "&startDate=" +
              startDate +
              "&endDate=" +
              endDate +
              "&fileName=",
            "_blank"
          );
        }
      }
    },
    GetModalityCountByDepartId() {
      this.isloading = true;
      this.$store
        .dispatch("GetModalityCountByDepartId", {
          startDate: this.DateArray[0],
          endDate: this.DateArray[1],
        })
        .then(() => {
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
      this.$store
        .dispatch("GetModalityCountForPI", {
          startDate: this.DateArray[0],
          endDate: this.DateArray[1],
        })
        .then(() => {
          this.isloading = false;
        })
        .catch(() => {
          this.isloading = false;
        });
    },
  },
  watch: {
    timeType(type) {
      this.checkTimeType(type);
    },
    type(datas) {
      if (datas === "检查量") {
        this.GetModalityCountByDepartId();
      } else {
        this.GetDoctorsWorkByDepartId();
      }
    },
    DateArray(datas) {
      if (this.type === "检查量") {
        this.GetModalityCountByDepartId();
      } else {
        this.GetDoctorsWorkByDepartId();
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
$background-color: #f8f8f8;
$font-size: 13px;
.reportList {
  .reportList-nav {
    height: auto;
    background: #f8f8f8;
    padding: 10px;
    .el-form-item {
      margin-bottom: 10px;
    }
    // .el-checkbox-button, .el-checkbox-button__inner{
    //   margin-right: 10px;
    // }
  }
  .reportList-table {
    border-top: 2px solid #dddddd;
    background: #f3f5f9;
  }
}
</style>
